/**
 * Lista los tipos de CAS (peligros existentes).
 *
 * @param {*} state
 */
export function setTiposCas(state, tiposCas) {
    state.tiposCas = tiposCas;
}

/**
 * Lista los controles.
 *
 * @param {*} state
 */
 export function setControles(state, controles) {
    state.controles = controles;
}

/**
 * Lista los componentes.
 *
 * @param {*} state
 */
 export function setComponentes(state, componentes) {
    state.componentes = componentes;
}

/**
 * Lista los componentes segun peligro.
 *
 * @param {*} state
 */
 export function setComponentesPeligro(state, componentesPeligro) {
    state.componentesPeligro = componentesPeligro;
}

/**
 * Filtro de busqueda de componentes sefun peligro.
 *
 * @param {*} state
 */
 export function setFiltroBuscador(state, parametros) {
    if(!parametros.peligro_id.isTrusted){
        state.parametrosBuscador.peligro_id = parametros.peligro_id
    }
    state.parametrosBuscador.buscar = parametros.buscar
    state.parametrosBuscador.page = parametros.page
}

/**
 * Limpiar filtro de busqueda de componentes segun peligro.
 *
 * @param {*} state
 */
 export function resetFiltroBuscador(state) {
    state.parametrosBuscador.buscar = ''
    state.parametrosBuscador.perPage = 10
    state.parametrosBuscador.page = 1
}

/**
 * Lista los valores de un componente de peligro.
 *
 * @param {*} state
 */
 export function setValoresComponentePeligro(state, valoresComponente) {
    state.valoresComponente = valoresComponente;
}

/**
 * Función para paginar
 *
 * @param {*} state
 */
 export function setPorPagina(state, perPage) {
    state.parametrosBuscador.page = 1;
    state.parametrosBuscador.perPage = perPage
}

/**
 * Función para cambiar de pagina
 *
 * @param {*} state
 */
export function setPagina(state, page) {
    state.parametrosBuscador.page = page
}

/**
 * Lista los componentes.
 *
 * @param {*} state
 */
 export function establecerTodosComponentes(state, todosLoscomponentes) {
    state.todosLoscomponentes = todosLoscomponentes;
}

/**
 * Función para paginar componentes
 *
 * @param {*} state
 */
 export function setPorPaginaComponentes(state, perPage) {
    state.parametrosBuscadorComponente.page = 1;
    state.parametrosBuscadorComponente.perPage = perPage
}

/**
 * Función para cambiar de pagina componentes
 *
 * @param {*} state
 */
export function setPaginaComponentes(state, page) {
    state.parametrosBuscadorComponente.page = page
}

/**
 * Filtro de busqueda de componentes.
 *
 * @param {*} state
 */
 export function setFiltroBuscadorComponente(state, parametros) {
    state.parametrosBuscadorComponente.buscar = parametros.buscar
    state.parametrosBuscadorComponente.page = parametros.page

    if ('active' in parametros && parametros.active) state.parametrosBuscadorComponente.active = parametros.active
}

/**
 * Limpiar filtro de busqueda de componentes.
 *
 * @param {*} state
 */
 export function resetFiltroBuscadorComponente(state) {
    state.parametrosBuscadorComponente.buscar = ''
    state.parametrosBuscadorComponente.cas_family = null
    state.parametrosBuscadorComponente.perPage = 10
    state.parametrosBuscadorComponente.page = 1
}

/**
 * Lista el componente.
 *
 * @param {*} state
 */
 export function setComponente(state, componente) {
    state.componente = componente;
}

/**
 * Resetear el componente.
 *
 * @param {*} state
 */
 export function resetComponente(state) {
    state.componente = {};
}

/**
 * Lista el componente.
 *
 * @param {*} state
 */
 export function setComponentesProducto(state, componentesProducto) {
    state.componentesProducto = componentesProducto;
}

/**
 * Resetear el formulario de agregar componente a producto.
 *
 * @param {*} state
 */
 export function resetFormComponente(state) {
    state.formComponente =  {
        visible: 1,
        percentaje_symbol_from: '=',
        percentaje_symbol_until: '',
        percentaje_range: 0,
        subproduct: 0,
    }
}

/**
 * Lista componentes por producto y peligro.
 *
 * @param {*} state
 */
 export function setComponentesProductoPeligro(state, componentesProductoPeligro) {
    state.componentesProductoPeligro = componentesProductoPeligro;
}

/**
 * Limpia los componentes.
 *
 * @param {*} state
 */
 export function resetearComponentes(state) {
    state.componentes = [];
}

/**
  * Establecer modal_producto_componente
*/
 export function establecerModalProductoComponente(state, ver) {
    state.modal_producto_componente.ver = ver;
}

/**
 * Establecer datos del comoponente a aprobar o desaprobar
 */
export function setComponentApprove(state, componentApprove){
    state.componentApprove = {
        ...componentApprove,
        reason: componentApprove.reason || '',
    }
}

/**
 * Establecer lista de componentes aprobados y desaprobados
 */
export function setProdComponentApprovedList(state, componentApprovedList){
    state.componentApprovedList = componentApprovedList;
}


/**
 * Función para setear el filtro de familia.
 *
 * @param {*} state
 */
export function setFamilyId(state, cas_family) {
    state.parametrosBuscadorComponente.cas_family = cas_family
}


/**
 * Establecer el peligro activo.
 * 
 * @param Object state 
 * @param Object nextState 
 */
export function setCurrentDangerActive(state, nextState) {
    state.currentDangerActive = nextState
}
/**
 * Establecer el respuesta del proceso de cargar archivo excel con componentes para asignar a un peligro.
 * 
 * @param Object state 
 * @param Object nextState 
 */
export function setResponseUpFileExcelComponents(state, nextState) {
    state.responseUpFileExcelComponents = nextState
}
